import { Button, Typography } from "antd";
import FeedbackForm from "./Screening/modal/feedbackForm";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getData } from "../../../../actions/apiCall";
import { MasterConfigs } from "../../../../interfaces/entity";
import FormSetup from "../../../../components/Forms/FormSetup";
import MasterComponent from "../../../../components/Forms";
import Badge from "../../../../components/Badge";
import moment from "moment";
import SmallProfileCard from "../../../../components/ContactInfo/SmallProfileCard";
import { constants } from "../../../../constants/common";
const { Title } = Typography;

const CandidateFeedback = ({ refId, highlighted, level }) => {
    const [feedbackForm, setFeedbackForm] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [id, setId] = React.useState(null);
    const dispatch = useDispatch();

    const config: MasterConfigs = {
        api: () => `/feedback?developer=${refId}`,
        getColumns: () => [
            {
                title: 'Interviewer',
                dataIndex: 'addedBy',
                key: 'addedBy',
                width: 300,
                render: (text) => <SmallProfileCard
                    name={constants.GET_FULL_NAME(text)}
                    avatar={text?.avatar}
                    subTitle={text?.email}
                />,
            },
            {
                width: 200,
                title: 'Round Type',
                dataIndex: 'level',
                key: 'level',
                render: (text) => constants.PROFILE_STATUS_TEXT[text] || text,
            },
            {
                width: 200,
                title: 'Comments',
                dataIndex: 'comments',
                key: 'comments',
                render: (text) => <Typography.Text ellipsis>{text}</Typography.Text>,
            },
            {
                width: 200,
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                align: 'center',
                render: (date) => moment(date).format('lll'),
            },
            {
                width: 200,
                title: 'Status',
                dataIndex: 'approvalStatus',
                key: 'approvalStatus',
                align: 'center',
                render: (status) => (
                    <Badge color={status == 'Rejected' ? 'red' : 'green'} text={status} />
                ),
            },
        ]
    }

    useEffect(() => {
        getFeedbackData();
    }, [refId]);


    const getFeedbackData = async () => {
        if (refId) {
            const resData = await dispatch(getData(`/api/feedback/${refId}`));
            if (resData) {
                setData(resData);
            }
        }
    };

    const onAddFeedback = () => {
        setFeedbackForm(true);
        setData(null);
    };



    return <>
        <div className="flex justify-between items-center py-2 px-4 border-b">
            <Title level={5} className={highlighted === 'feedback' ? 'bg-yellow-200 px-1' : ''}>Feedback</Title>
            <Button type="text" onClick={() => onAddFeedback()}>Add Feedback</Button>
        </div>
        <div className="p-4">
            <FeedbackForm data={data} id={refId} isVisible={feedbackForm} onClose={() => setFeedbackForm(false)} level={level} />
            <MasterComponent config={config} />
        </div>
    </>
}


export default CandidateFeedback;